import { Box } from '@mui/material';
import _ from 'lodash';
import { type FC, memo } from 'react';
import { EnvironmentWatermarkLine } from './EnvironmentWatermarkLine';
import { useEnvironmentIndicatorStore } from './store';

export const EnvironmentWatermark: FC = memo(() => {
  const shouldShow = useEnvironmentIndicatorStore((state) => state.shouldShow());

  if (!shouldShow) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 0,
        overflow: 'hidden',
      }}
    >
      {_.range(30).map((index) => (
        <Box
          key={index}
          sx={{
            position: 'absolute',
            transform: 'rotate(-35deg)',
            transformOrigin: 'center',
            top: `${-200 + index * 60}px`,
            left: '-20%',
            width: '200%',
          }}
        >
          <EnvironmentWatermarkLine />
        </Box>
      ))}
    </Box>
  );
});
